// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__2MaFJ","file":"styles_file__3-Mp3"};